module.exports = __webpack_public_path__ + "static/media/begin_driving.df908754.png";